import cx from 'clsx';

import { Text } from '@manage-cards/constants';
import { CardFilterType, IUserSummaryDetails } from '@manage-cards/types';

import { Image, InteractiveElement } from '@shared/components/core';

import bankIcon from '@assets/icons/bankIcon.svg';
import LogoutIcon from '@assets/icons/logout.svg';

import styles from './MerchantCardList.module.scss';

export type MerchantCardOptionItem = {
	id: string;
	icon: string;
	selected: boolean;
	title: string;
};

interface IMerchantCardListProps {
	filterType: CardFilterType;
	itemList: Array<MerchantCardOptionItem>;
	userDetails: IUserSummaryDetails;
	onItemSelect: (itemId: string) => void;
	onFilterChange: (filter: CardFilterType) => void;
	logout: () => void;
}

const MerchantCardList = ({
	filterType,
	itemList = [],
	userDetails,
	onItemSelect,
	onFilterChange,
	logout,
}: IMerchantCardListProps) => {
	const Filters = (
		<div
			className={cx(
				'd-flex justify-center border-bottom1 border-grey2 gap4 py3 px4',
			)}
		>
			{[CardFilterType.BY_CARD, CardFilterType.BY_SELLER].map((type) => (
				<InteractiveElement
					key={type}
					type="span"
					className={cx(
						styles.filterOption,
						'pointer h4 lighter dark3 border1 border-grey2 border-radius2 center-align p2',
						{
							[styles.selectedFilter]: filterType === type,
						},
					)}
					onClick={() => onFilterChange(type)}
				>
					{type === CardFilterType.BY_CARD ? Text.BY_CARD : Text.BY_SELLER}
				</InteractiveElement>
			))}
		</div>
	);

	return (
		<>
			{Filters}
			<div
				className={cx('py4 flex1 overflow-y-auto', styles.optionListContainer)}
			>
				{itemList.map((item) => (
					<InteractiveElement
						type="div"
						key={item.id}
						onClick={() => onItemSelect(item.id)}
						className={cx(
							styles.optionItem,
							{
								[styles.selected]: item.selected,
							},
							'd-flex p4 gap3 items-center pointer',
						)}
					>
						{item.icon && (
							<Image
								height={32}
								width={32}
								className="border-radius2"
								src={item.icon}
								fallbackImage={bankIcon}
								alt="instrument icon"
							/>
						)}
						<div className="flex1 d-flex items-center gap2">
							<p className={cx('m0 h4 dark3 truncate', styles.heading)}>
								{item.title}
							</p>
						</div>
					</InteractiveElement>
				))}
			</div>
			<InteractiveElement
				type="div"
				className={cx(
					styles.logoutContainer,
					'p5 d-flex items-center mb4 pointer width-fit-content',
				)}
				onClick={logout}
			>
				<div className="d-flex gap3">
					<Image height={32} width={32} src={LogoutIcon} alt="Logout" />
					<div className="d-flex flex-column gap2">
						<span className="h4 light dark3">{Text.LOGOUT}</span>
						<span className="h5 lighter dark2">{userDetails.phoneNumber}</span>
					</div>
				</div>
			</InteractiveElement>
		</>
	);
};

export default MerchantCardList;
